module.exports = __webpack_public_path__ + "static/media/default-image.d4c5863c.jpg";